// eslint-disable-next-line max-classes-per-file
import PersonType from '../../enums/PersonType';

export class PayrollInvoiceWorkerViewModel {
  id: number;
  invoiceId: number;
  invoiceNumber: string;
  invoiceStartedAt: Date;
  invoiceFinishedAt: Date;
  transactionNature: string;
  workerId: number;
  workerName: string;
  value: number;
  paidAt: Date;
  customerName: string;
  bonus: number;
  checked: boolean = false;

  constructor(data: any = {}) {
    this.id = data.id;
    this.invoiceId = data.invoiceId;
    this.invoiceNumber = data.invoiceNumber;
    this.invoiceStartedAt =
      data.invoiceStartedAt && new Date(data.invoiceStartedAt);
    this.invoiceFinishedAt =
      data.invoiceFinishedAt && new Date(data.invoiceFinishedAt);
    this.transactionNature = data.transactionNature;
    this.workerId = data.workerId;
    this.workerName = data.workerName;
    this.value = data.value;
    this.paidAt = data.paidAt && new Date(data.paidAt);
    this.customerName = data.customerName;
    this.bonus = data.bonus;
  }

  public toggleChecked() {
    this.checked = !this.checked;
  }
}

export class PayrollViewModel {
  createdAt: string;
  updatedAt: string;
  id: number;
  companyId: number;
  companyType: PersonType;
  companyIdentifier: string;
  companyName: string;
  companyAlias: string;
  startDate: string;
  endDate: string;
  canRemove: boolean;

  constructor(data: any = {}) {
    this.id = data.id;
    this.createdAt = data.createdAt && new Date(data.createdAt);
    this.updatedAt = data.updatedAt && new Date(data.updatedAt);
    this.companyId = data.companyId;
    this.companyType = data.companyType;
    this.companyIdentifier = data.companyIdentifier;
    this.companyName = data.companyName;
    this.companyAlias = data.companyAlias;
    this.startDate = data.startDate && new Date(data.startDate);
    this.endDate = data.endDate && new Date(data.endDate);
    this.canRemove = data.canRemove;
  }
}
